import React from 'react';

import { useService } from '@xstate/react';
import styled from 'styled-components'

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import {
  getDayColourNameFromColour,
  getDayColourOptions,
  productHasColour,
} from '../../../helpers/colour';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { productHasVariantWithMaterialType } from '../../../helpers/material';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorColour } from '../../Common/Selector';
import { AddFreeSample } from './AddFreeSample';
// import { SectionContent } from './SectionContent';

const hexSorter = require('hexsorter');

const Wrapper = styled.div`
  width: 100%;

  .keen-slider {
    justify-content: center;
  }

  .keen-slider-selector__slide {
      margin: 0 5px;
      min-width: 45px !important;
      max-width: 45px !important;
  }

  @media (min-width: 1441px) {
    padding-top: 30px;
  }

  @media (max-width: 1440px) {
    width: 100%;
    max-width: 100%;
  }
`;

type OnClick = (
  dayColour: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (dayColour, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      dayColour,
      dayFabricPosition: 'Top',
    },
  });

// type OnMouseOver = (
//   dayColour: string,
//   send: (event: ProductBuilderMachineEvent) => void,
// ) => () => void;

// const onMouseOver: OnMouseOver = (dayColour, send) => () =>
//   send({
//     type: 'UPDATE_CUSTOM',
//     custom: {
//       dayColour,
//     },
//   });

export const DayColour = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    products,
    custom: { materialType, dayColour, colourNight },
  } = state.context;

  const colourOptions = getDayColourOptions(
    products
      .filter(productHasVariantWithMaterialType(materialType))
      .filter(productHasColour(colourNight)),
  );

  let colourHexValues: string[] = colourOptions.map(colour => colour.code);
  var mostBright = hexSorter.sortColors(colourHexValues, 'mostBrightColor');

  let sortedOptions;
  /**
   * Sort array of objects based on another array
   */

  const mapOrder = (
    array: {
      name: string;
      code: string;
      featured_image: string;
      '25mm_swatch_url': string;
      '45mm_swatch_url': string;
    }[],
    order: string[],
    key: string,
  ) => {
    array.sort((a: any, b: any) => {
      const A = a[key];
      const B = b[key];
      return order.indexOf(A) > order.indexOf(B) ? 1 : -1;
    });
    return array;
  };

  sortedOptions = mapOrder(colourOptions, mostBright, 'code');

  if (isCurrentState('dayColour', state) && colourOptions.length === 0) {
    throwError(state);
  }

  return (
    <Wrapper>
      <Heading>Day Colour</Heading>
      <Selector isSlider={true} isColorPicker={true} isColorArrow={true}>
        {colourOptions.map(option => {
          const isSelected = option.name === dayColour;
          return (
            <SelectorColour
              isSelected={isSelected}
              onClick={onClick(option.name, send)}
              key={option.name}
              colourName={option.name.split('(').shift() || ''}
              colourCode={option.code}
              colourSwatch={option['25mm_swatch_url']}
            />
          );
        })}
      </Selector>
      <Caption>{getDayColourNameFromColour(dayColour)}</Caption>
      <AddFreeSample title={getDayColourNameFromColour(dayColour || '')} />
    </Wrapper>
  );
};
